<template>
  <div
    class="detail-row detail-row--custom"
    :class="{
      'detail-row--capex': deduction.deduction_mode === 'capital_expenditure',
    }"
  >
    <div class="detail-row__content">
      <div class="detail-row__label">
        <v-icon x-small :color="categoryColor" class="mr-1">{{
          categoryIcon
        }}</v-icon>
        <span>{{ deduction.name }}</span>
        <v-chip
          v-if="deduction.type === 'percentage'"
          x-small
          label
          outlined
          class="ml-2"
          color="grey"
        >
          {{ deduction.value }}%
        </v-chip>
      </div>
      <span v-if="deduction.notes" class="detail-row__notes caption grey--text">
        {{ deduction.notes }}
      </span>
    </div>
    <div class="detail-row__right">
      <span class="detail-row__value red--text text--darken-1">
        {{ formatCurrency(deduction.computed_amount) }}
      </span>
      <div class="detail-row__actions">
        <v-btn
          icon
          x-small
          color="grey"
          class="ml-1"
          @click.stop="$emit('edit', deduction)"
        >
          <v-icon x-small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          icon
          x-small
          color="red"
          class="ml-1"
          @click.stop="$emit('delete', deduction)"
        >
          <v-icon x-small>mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeductionListItem",
  props: {
    deduction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    categoryIcon() {
      const icons = {
        logistics: "mdi-truck",
        commission: "mdi-account-cash",
        tax: "mdi-file-document",
        service: "mdi-tools",
        discount: "mdi-tag-minus",
        other: "mdi-dots-horizontal-circle",
      };
      return icons[this.deduction.category] || icons.other;
    },
    categoryColor() {
      const colors = {
        logistics: "orange",
        commission: "purple",
        tax: "blue",
        service: "teal",
        discount: "green",
        other: "grey",
      };
      return colors[this.deduction.category] || colors.other;
    },
  },
  methods: {
    formatCurrency(val) {
      const num = parseFloat(val) || 0;
      return (
        "₱ " +
        num.toLocaleString("en-PH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 4px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #fff3e0;
  }

  &--custom {
    border-left: 3px solid #ff9800;
    background-color: #fffbf5;

    &:hover {
      background-color: #fff3e0;

      .detail-row__actions {
        opacity: 1;
      }
    }
  }

  &--capex {
    border-left-color: #f57c00;
    background-color: #fff8e1;

    &:hover {
      background-color: #fff3e0;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  &__label {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #3c4043;
  }

  &__notes {
    margin-top: 2px;
    padding-left: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }

  &__right {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__value {
    font-size: 13px;
    font-weight: 500;
    font-variant-numeric: tabular-nums;
  }

  &__actions {
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.15s ease;
    margin-left: 8px;
  }
}
</style>
